import React from "react";
import { SITE_URL, SITE_NAME, DEFAULT_OG_IMAGE } from "../lib/seoData";

// React 19 natively hoists <title>, <meta> and <link> rendered anywhere in the
// tree into <head>, and removes them on unmount (route change). This is more
// reliable than imperative head libraries and is captured cleanly by react-snap.
export const SEO = ({
  title,
  description,
  path = "/",
  image = DEFAULT_OG_IMAGE,
  keywords,
  jsonLd,
}) => {
  const url = `${SITE_URL}${path}`;
  const graphNodes = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];
  const structuredData =
    graphNodes.length > 0
      ? { "@context": "https://schema.org", "@graph": graphNodes }
      : null;

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {structuredData && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
        />
      )}
    </>
  );
};

export default SEO;
